import { Fragment, h } from 'preact';
import PropTypes from 'prop-types';

import { IconAvatarPlaceholderEmpty, IconAvatarPlaceholderFilled } from '../../1-foundation/icons/icons';

const LoginBar = ({
  personalizeLabelLogin,
  personalizeLabelLogout,
  loginLabel,
  logoutLabel,
  onPersonalizeUrlClick,
  onLogin = () => {},
  onLogout = () => {},
  isLogged,
}) => {
  const IconAvatarPlaceholder = isLogged ? IconAvatarPlaceholderFilled : IconAvatarPlaceholderEmpty;
  const iconAvatarPlaceholderModifiers = isLogged
    ? ['mix', 'avatar-placeholder-filled', 'xsmall']
    : ['mix', 'avatar-placeholder-empty', 'xsmall'];
  const personalizeLabel = isLogged ? personalizeLabelLogout : personalizeLabelLogin;

  return (
    <div className="c-login-bar">
      <Fragment>
        <button type="button" className="c-login-bar__personalize" onClick={onPersonalizeUrlClick}>
          <div className="c-login-bar__personalize-icon">
            <IconAvatarPlaceholder modifiers={iconAvatarPlaceholderModifiers} />
          </div>
          <div className="c-login-bar__personalize-label">{personalizeLabel}</div>
        </button>
        <div className="c-login-bar__separator" />
      </Fragment>
      <a className="c-login-bar__label" onClick={isLogged ? onLogout : onLogin}>
        {isLogged ? logoutLabel : loginLabel}
      </a>
    </div>
  );
};

LoginBar.propTypes = {
  personalizeLabelLogin: PropTypes.string,
  personalizeLabelLogout: PropTypes.string,
  loginLabel: PropTypes.string.isRequired,
  logoutLabel: PropTypes.string.isRequired,
  onLogin: PropTypes.func,
  onLogout: PropTypes.func,
  onPersonalizeUrlClick: PropTypes.func,
  isLogged: PropTypes.bool,
};

export default LoginBar;
